import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-espaco-professor-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './espaco-professor-layout.component.html',
  styleUrl: './espaco-professor-layout.component.scss'
})
export class EspacoProfessorLayoutComponent {

}
